{
  "#WWS_DELIVERY_NOTE_CORRECTION": {
    "TITLE": "Lieferschein-Korrektur"
  }
}
